import React, { useState, useEffect, useCallback } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import moment from "moment";
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl, isPossiblePhoneNumber, isValidPhoneNumber } from "react-phone-number-input";
import cookie from "react-cookies";
import axios from "axios";
import bg from "assets/bg.png";
import logo from "assets/logo.png";
import "./App.scss";
import Home from "components/home";
import Banner from "components/banner";
import Qa from "components/qa";
import Logo from "components/logo";
import NoAnswer from "components/noAnswer";
import Status from "components/status";
import Result from "components/result";
import Modal from "components/modal";
import ModalWarning from "components/modalWarning";
import { func, string } from "prop-types";

const $timeout = delay => new Promise(r => setTimeout(r, delay));

// const baseUrl =
//   "https://h8y8ckttvj.execute-api.eu-central-1.amazonaws.com/dev/";
const baseUrl = "https://0q6c3fg6al.execute-api.eu-central-1.amazonaws.com/prod/";
const renderTime = value => {
  // if (value === 0) {
  //   return <div className="timer">Too lale...</div>;
  // }
  return (
    <div className="timer">
      <div className="value">{value}</div>
    </div>
  );
};

function App() {
  const axiosConfig = {
    withCredentials: true,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  };

  const [startScreen, setStartScreen] = useState(true);
  const [competitionStatus, setCompetitionStatus] = useState(false);
  const [question, setQuestion] = useState(null);
  const [userRight, setUserRight] = useState(true);
  const [correctAnswer, setCorrectAnswer] = useState(null);
  const [competitionComplete, setCompetitionComplete] = useState(false);
  const [countDown, setCountDown] = useState(false);
  const [timeOver, setTimeOver] = useState(false);
  const [answerStatus, setAnswerStatus] = useState(null);
  const [noAnswer, setNoAnswer] = useState(false);
  const [resultScreen, setResultScreen] = useState(false);
  const [resultCode, setResultCode] = useState(null);
  const [answered, setAnswered] = useState(false);
  const [phoneGet, setPhoneGet] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [modal, setModal] = useState(false);
  const [NFphone, setNFphone] = useState("");
  const [validPhone, setValidPhone] = useState(false);
  const [kvkk, setKvkk] = useState(false);
  const [ww, setWW] = useState(0);
  const [maxLength, setMaxLength] = useState("");
  const [modalWarning, setModalWarning] = useState(false);

  function getKvkk() {
    setKvkk(kvkk == false ? true : false);
  }

  function CountDown(props) {
    return (
      <div className="container countDown">
        <CountdownCircleTimer
          isPlaying
          renderTime={renderTime}
          durationSeconds={12}
          colors={[["#ff6400"]]}
          size={ww < 576 ? 44 : 84}
          strokeWidth={5}
          onComplete={() => {
            // do your stuff here
            setCountDown(false);
            setTimeOver(true);
            setNoAnswer(true);
            updateQuestions();
            return [false, 1000]; // repeat animation in 1.5 seconds
          }}
        />
      </div>
    );
  }

  const auth = async () => {
    const expires = new Date();
    expires.setDate(expires.getDate() + 20);
    console.log(expires);

    let authData = {
      user_id:
        !localStorage.getItem("uID") && !cookie.load("userId")
          ? ""
          : localStorage.getItem("uID") && cookie.load("userId")
          ? localStorage.getItem("uID")
          : localStorage.getItem("uID") && !cookie.load("userId")
          ? localStorage.getItem("uID")
          : !localStorage.getItem("uID") && cookie.load("userId")
          ? cookie.load("userId")
          : ""
      // localStorage.getItem("uID") !== string && cookie.load('userId') === undefined ? "" : cookie.load('userId') !== undefined && localStorage.getItem("uID") !== string  ? cookie.load('userId') : cookie.load('userId') === undefined && localStorage.getItem("uID") === string ? localStorage.getItem("uID") : localStorage.getItem("uID") === string ? localStorage.getItem("uID") :  ""
    };
    await $timeout(400);
    const req = await axios.post(baseUrl + "authenticate", authData);
    const data = await req.data;

    if (data.status) {
      localStorage.setItem("uID", data.user_id);
      cookie.save("userId", data.user_id, {
        expires
      });
      setPhoneGet(data.number);
      setAnswerStatus(null);
      setCompetitionStatus(true);
    }
  };

  useEffect(() => {
    auth();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", setWW);
    setWW(window.innerWidth);

    function hasTouch() {
      return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }

    if (hasTouch()) {
      // remove all the :hover stylesheets
      try {
        // prevent exception on browsers not supporting DOM styleSheets properly
        for (var si in document.styleSheets) {
          var styleSheet = document.styleSheets[si];
          if (!styleSheet.rules) continue;

          for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
            if (!styleSheet.rules[ri].selectorText) continue;

            if (styleSheet.rules[ri].selectorText.match(":hover")) {
              styleSheet.deleteRule(ri);
            }
          }
        }
      } catch (ex) {}
    }
  });

  const updateQuestions = async () => {
    setQuestion({
      questionID: question.questionID,
      questionTitle: question.questionTitle,
      answers: question.answers.map(answer => (answer ? { ...answer, disabled: true } : answer))
    });
    await $timeout(200);

    let answerData = {
      question_id: question.questionID,
      answer: "",
      user_id: localStorage.getItem("uID") ? localStorage.getItem("uID") : cookie.load("userId") ? cookie.load("userId") : ""
    };

    const req = await axios.post(baseUrl + "answer", answerData);
    const data = await req.data;
    await $timeout(2000);
    setQuestion(null);
    setStartScreen(false);
    setResultCode(2);
    setResultScreen(true);
    setNoAnswer(false);
  };

  const keydown = event => {
    // if(event.keyCode !== 8 && validPhone) {
    //  event.preventDefault()
    // }
  };
  const getNumber = phone => {
    setPhoneNumber(phone);
    setValidPhone(phone && isValidPhoneNumber(phone) ? true : false);
  };

  const getPhoneNF = async event => {
    setNFphone(event.value);
  };

  const sendNumber = async () => {
    let phoData = {
      user_number: phoneNumber,
      user_id: localStorage.getItem("uID") ? localStorage.getItem("uID") : cookie.load("userId") ? cookie.load("userId") : ""
    };
console.log(kvkk + 'kvkk')
console.log(modalWarning)
    if (validPhone && !kvkk) {
        setModalWarning(modalWarning === false ? true : false)
    }

    if (validPhone && kvkk) {
      const req = await axios.post(baseUrl + "submitNumber", phoData);
      const data = req.data;
      if (data.status) {
        setPhoneGet(true);
        setPhoneNumber("");
      }
    }
  };

  const openModal = async () => {
    setModal(modal === false ? true : false);
  };

  const openWarningModal = async () => {
    setModalWarning(modalWarning === false ? true : false);

  }

  const startCompetition = async () => {
    setPhoneNumber("");
    setNFphone("");
    setResultScreen(false);
    let strartCompetitionData = {
      user_id: localStorage.getItem("uID") ? localStorage.getItem("uID") : cookie.load("userId") ? cookie.load("userId") : ""
    };
    const req = await axios.post(baseUrl + "startCompetition", strartCompetitionData);
    const data = await req.data;
    if (data.question !== null) {
      let answersData = data.question.answers.map(function(answer) {
        return {
          id: answer.id,
          title: answer.title,
          selected: false,
          correct: false,
          wrong: false,
          disabled: false
        };
      });
      await $timeout(500);
      let questionData = {
        questionID: data.question.questionID,
        questionTitle: data.question.questionTitle,
        answers: answersData
      };
      setQuestion(questionData);
      setAnswerStatus(null);
      setStartScreen(false);
      setCountDown(true);
    } else {
      setQuestion(null);
      setUserRight(false);
      setResultCode(3);
      setStartScreen(false);
      setResultScreen(true);
    }
  };

  const answerQuestion = async (item, index) => {
    setCountDown(false);
    setAnswered(true);
    setQuestion({
      questionID: question.questionID,
      questionTitle: question.questionTitle,
      answers: question.answers.map(answer => (answer.id == item.id ? { ...answer, selected: true, disabled: true } : answer.id == item.id ? { ...answer, selected: true, disabled: true } : answer ? { ...answer, disabled: true } : answer))
    });
    await $timeout(500);
    let answerData = {
      question_id: question.questionID,
      answer: item.id == 1 ? "A" : item.id == 2 ? "B" : "C",
      user_id: localStorage.getItem("uID") ? localStorage.getItem("uID") : cookie.load("userId") ? cookie.load("userId") : ""
    };

    const req = await axios.post(baseUrl + "answer", answerData);
    const data = await req.data;

    await $timeout(500);

    if (data) {
      let bb = data.answer == "A" ? 1 : data.answer == "B" ? 2 : data.answer == "C" ? 3 : null;
      setCorrectAnswer(data.answer == "A" ? 1 : data.answer == "B" ? 2 : data.answer == "C" ? 3 : null);
      setCompetitionComplete(data.is_competition_completed);
      await $timeout(500);
      setQuestion({
        questionID: question.questionID,
        questionTitle: question.questionTitle,
        answers: question.answers.map(answer =>
          answer.id == bb ? { ...answer, disabled: true, correct: true } : answer.id == item.id && item.id !== bb ? { ...answer, disabled: true, selected: true, wrong: true } : answer ? { ...answer, disabled: true } : answer
        )
      });
      setAnswerStatus(data.is_answer_correct);
    }
    await $timeout(2000);
    // if (!data.is_competition_completed) {
    //   setAnswered(false)
    //   startCompetition();
    // }

    if (!data.is_answer_correct && data.is_competition_completed) {
      setStartScreen(false);
      setQuestion(null);
      setAnswered(false);
      setResultCode(2);
      setResultScreen(true);
    } else if (data.is_answer_correct && !data.is_competition_completed) {
      startCompetition();
    } else {
      setAnswered(false);
      setStartScreen(false);
      setQuestion(null);
      setResultCode(1);
      setResultScreen(true);
    }
  };

  return (
    <div className="App">
      <div className="widgetcontainer" style={{ backgroundImage: "url(" + bg + ")" }}>
        {startScreen ? <Home startClick={startCompetition} competitionStatus={competitionStatus} /> : null}
        {!startScreen && question !== null ? (
          <Qa
            data={question}
            // questionAnswers={questionAnswers}
            answerQuestion={answerQuestion}
            // disabled={dClick}
            // selectedAnswer={selectedId}
          />
        ) : null}
        {!startScreen && question !== null && countDown ? (
          <div>
            <CountDown />
          </div>
        ) : null}
        {!startScreen && question !== null ? <Logo /> : null}
        {!startScreen && answered ? <Status status={answerStatus} statusText={answerStatus !== null && answerStatus == true ? "Doğru Cevap" : !answerStatus && answerStatus !== null ? "Yanlış Cevap" : null} /> : null}
        {!startScreen && noAnswer ? <NoAnswer status={noAnswer} statusText={noAnswer ? "Cevaplamadınız" : null} /> : null}

        {resultScreen ? (
          <Result
            resultCode={resultCode}
            validPhone={validPhone}
            phoneGet={phoneGet}
            kvkk={kvkk}
            getNumber={getNumber}
            sendNumber={sendNumber}
            startClick={startCompetition}
            userRight={userRight}
            getKvkk={getKvkk}
            openModal={openModal}
            openWarningModal={openWarningModal}
            getPhoneNF={getPhoneNF}
            NFphone={NFphone}
            phoneNumber={phoneNumber}
            max={maxLength}
            keydown={keydown}
          />
        ) : null}
        {modal ? <Modal openModal={openModal} /> : null}
        {modalWarning ? <ModalWarning openModal={openWarningModal} /> : null}
        {startScreen && !resultScreen ? <Banner /> : null}
      </div>
    </div>
  );
}

export default App;
